import React, {useEffect, useState} from 'react';
import OtpSentIcon from '../Assets/SVG/otpSentIcon';
import Footer from '../Assets/footer';
import TextInput from '../../../Shared/TextInput/TextInput';
import Popup from '../../../Shared/Popup/PopUp';
import PopupWithAnimation from '../../../Shared/PopUpWithAnimation/PopUpWithAnimation';

import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import Config from '../../../../Config';
import SendAgain from '../Assets/SVG/sendAgain';
import PhoneIcon from '../Assets/SVG/phoneIcon';
import HandWaveIcon from '../Assets/SVG/handWaveIcon';

import SendVoice from '../Assets/SVG/sendVoice';
import CheckBox from '../../../Shared/CheckBox/Checkbox';
import {isMobile} from 'react-device-detect';
import {setOtpError, setRestrictedCodeError} from 'app/utilities/authentication/authenticationSlice';
import {connect} from 'react-redux';
import OtpExtendedPopup from '../../../Shared/OtpExtendedPopUp/OtpExtendedPopup';
import ArrowSignErrorIcon from '../Assets/SVG/arrowSignErrorIcon';

const OTPInsert = (props) => {
  const [otpCode, setCode] = useState('');
  const [numOfAttempts, setNumOfAttempts] = useState(0);
  const [checkBoxChecked, setCheckBoxIsChecked] = useState(false);
  const [isErrorCheck, setErrorCheck] = useState(false);
  const [showTrackPopup, setshowTrackPopup] = useState(false);
  const [showExpiryPopup, setShowExpiryPopup] = useState(false);
  const [showMaxPopup, setShowMaxPopup] = useState(false);
  const [valiCode, setValiCode] = useState('');
  const [isNoTrack, setNoTrack] = useState(false);
  const [showContactPopup, setshowContactPopup] = useState(false);

  useEffect(() => {
    async function fetchOtp() {
      /*const input = document.querySelector('input[autocomplete="one-time-code"]');
            if (!input) return;
            const ac = new AbortController();
            const form = input.closest('form');
            if (form) {
                form.addEventListener('submit', e => {
                    ac.abort();
                });
            }*/
      navigator.credentials
        .get({
          otp: {transport: ['sms']},
          //signal: ac.signal
        })
        .then(async (otp) => {
          let otpCodeRetrieved = otp.code.substring(0, 6);
          console.log('otp obtained', otpCodeRetrieved);
          setCode(otpCodeRetrieved);
          if (
            (!props.displayCode || (props.displayCode && valiCode?.length > 0)) &&
            (!props.showTerms || (props.showTerms && checkBoxChecked))
          ) {
            await validateCode(otpCodeRetrieved);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    if ('OTPCredential' in window) {
      console.log('otp is in window');
      fetchOtp();
    }

    setErrorCheck(false);
    setNumOfAttempts(0);
    props.setOtpError(null);
    props.setRestrictedCodeError(null);

    return () => {
      if (props.authentication.formError.otpCodeError) {
        props.setOtpError(null);
      }
      if (props.authentication.formError.restrictedCodeError) {
        props.setRestrictedCodeError(null);
      }
    };
  }, []);

  const validateCode = async (code = null) => {
    setNoTrack(false);
    let otpCodeSubmit = code ? code : otpCode;
    console.log('entered validateCode', {otpCode, valiCode});
    let checkedCodeContinue = true;
    if (props.showTerms && !checkBoxChecked) {
      setErrorCheck(true);
      return;
    }
    setErrorCheck(false);
    if (otpCodeSubmit == '' || otpCodeSubmit == null) {
      console.log('otp code is empty');
      props.setOtpError('יש להזין קוד אימות');
      checkedCodeContinue = false;
    }
    if ((valiCode == '' || valiCode == null) && props.displayCode) {
      console.log('valicode is empty');
      props.setRestrictedCodeError('יש להזין קוד זיהוי');
      checkedCodeContinue = false;
    }

    if (numOfAttempts > Config.verifyCodeAttemptsLimit) {
      props.setOtpError('לא ניתן לבצע ניסיונות נוספים');

      return;
    }
    if (!checkedCodeContinue) {
      console.log('checkedCodeContinue', checkedCodeContinue);
      return;
    }
    checkedCodeContinue = await props.onclick(otpCodeSubmit, valiCode);
    console.log('check', checkedCodeContinue);

    if (!checkedCodeContinue.isSuccess) {
      if (checkedCodeContinue.codeError == 1005) {
        setNumOfAttempts(numOfAttempts + 1);
      }
      if (checkedCodeContinue.codeError == 1003) {
        setShowExpiryPopup(true);
      }
      if (checkedCodeContinue.codeError == 1002) {
        setShowMaxPopup(true);
      }
    } else {
      props.setOtpError(null);
      if (checkedCodeContinue?.shouldExtend) {
        setshowContactPopup(true);
      }
    }
  };
  const resendOtp = async (val) => {
    setNoTrack(false);
    if (props.isVoice) val = false;
    const res = await props.sendAgain(val);
    setshowTrackPopup(res?.isShowPopup);
  };
  const subForOtp = `${props?.contactVal?.substring(5, 10)}**${props?.contactVal?.substring(0, 3)}`;
  const otpLabel = (
    <>
      שלחנו קוד ל-
      <span>{subForOtp}</span>
    </>
  );
  const textHeading = props.isVoice ? (
    <>
      כבר מתקשרים כדי להשמיע לכם
      <br />
      הודעה קולית עם קוד האימות
    </>
  ) : (
    otpLabel
  );
  const labelForCheck = (
    <span className='labelForCheck'>
      אישרתי את{' '}
      <a href={props.termsLink} target='_blank' rel='noopener noreferrer'>
        תקנון האתר
      </a>
    </span>
  );

  return (
    <div className='screenContainer'>
      <form
        onSubmit={async (e) => {
          e.preventDefault();
          if (!showContactPopup) await validateCode();
        }}>
        {props.isVoice ? <PhoneIcon /> : <OtpSentIcon />}
        {props.isFull && <h3 className='connectNotation'>התחברות</h3>}
        <h3 className='heading'>{textHeading}</h3>
        {props.isFull && <h4 className='enterCodeNotation'>הקלידו את הקוד שקיבלתם בהודעה</h4>}
        <TextInput
          autoFocus
          placeholder={'קוד אימות'}
          autoComplete='one-time-code'
          name='otp-code'
          value={otpCode}
          type='text'
          inputMode='numeric'
          maxLength={'6'}
          error={props.authentication.formError.otpCodeError}
          onChange={async (e) => {
            let isAutoCompleted = false;
            if (
              otpCode?.length == 0 &&
              e.target.value.length == 6 &&
              isMobile &&
              (!props.showTerms || (props.showTerms && checkBoxChecked)) &&
              (!props.displayCode || (props.displayCode && valiCode?.length > 0))
            ) {
              isAutoCompleted = true;
            }
            const numberRegex = /^\d+$/;
            if ((numberRegex.test(e.target.value) || e.target.value === '') && e.target?.value?.length <= 6) {
              setCode(e.target.value);
              props.setOtpError('');
              if (
                isAutoCompleted &&
                (!props.displayCode || (props.displayCode && valiCode?.length > 0)) &&
                (!props.showTerms || (props.showTerms && checkBoxChecked))
              ) {
                await validateCode(e.target.value.substring(0, 6));
              }
            }
          }}
        />
        <div className='resendButtons'>
          <div
            className='resendButton'
            onClick={async () => {
              await resendOtp(true);
            }}>
            <div>{props.isVoice ? <SendVoice /> : <SendAgain />}</div>
            <div className='text'>
              לא קיבלתי קוד,
              <br />
              תשלחו שוב
            </div>
          </div>
          {props.isVoice ? null : (
            <>
              <div className='separator'></div>
              <div
                className='resendButton'
                onClick={async () => {
                  await resendOtp(false);
                }}>
                <div>
                  <SendVoice />
                </div>
                <div className='text'>
                  שלחו לי
                  <br />
                  בהודעה קולית
                </div>
              </div>
            </>
          )}
        </div>
        {props.displayCode && (
          <div className='valiCode'>
            <TextInput
              placeholder={'קוד זיהוי'}
              value={valiCode}
              error={props.authentication.formError.restrictedCodeError}
              onChange={(e) => {
                setValiCode(e.target.value);
                props.setRestrictedCodeError(null);
              }}
            />
          </div>
        )}

        {props.showTerms && (
          <div className='checkZone'>
            <CheckBox
              id='readTermsCheckbox'
              onCheck={() => setCheckBoxIsChecked(true)}
              onUncheck={() => setCheckBoxIsChecked(false)}
              checked={checkBoxChecked}
              error={isErrorCheck ? 'יש לאשר את תקנון האתר' : ''}
              label={labelForCheck}
            />
          </div>
        )}
        {isNoTrack && <div className='error'>כרגע לא ניתן לשלוח קוד אימות קולי</div>}

        <Footer onclick={() => {}} stage={props.stage} />

        <Popup
          showPopUp={showTrackPopup}
          onClose={() => {
            setNoTrack(true);
            setshowTrackPopup(false);
          }}>
          <>
            <h3 className='heading'>לא ניתן לשלוח קוד אימות קולי</h3>
            <h4 className='secondaryHeading'>
              מאחר ומותקן למנוי זה שירות עקוב אחריי <br />
              לביצוע הפעולה יש להתקשר למוקד השירות במספר {window.Config.technicalSupportPhone}
            </h4>
            <BtnSubmit
              type='button'
              text={'הבנתי, תודה'}
              className='continueButton'
              onclick={() => {
                setNoTrack(true);
                setshowTrackPopup(false);
              }}
            />
          </>
        </Popup>
        <PopupWithAnimation
          className='selfcareExtendedOtpPopUp'
          isShow={showContactPopup}
          onClose={() => {
            props.finishExtended(false);
          }}>
          <OtpExtendedPopup
            title={'לצפיה בכל המנויים'}
            subtitle={'לצפיה ופעולות בכל המוצרים, נבקש הסכמה מבעל החשבון'}
            closeText={'תודה, בינתיים אשאר עם המנוי שלי'}
            setShowPopUp={() => {
              props.finishExtended(false);
            }}
            onAuthentication={() => {
              props.finishExtended(true);
            }}
          />
        </PopupWithAnimation>
        <Popup
          showPopUp={showExpiryPopup}
          onClose={async () => {
            setShowExpiryPopup(false);
            props.resetProcess();
          }}>
          <>
            <HandWaveIcon />
            <h3 className='heading withSecondary'>
              שמחים שחזרתם!
              <br />
              אבל הקוד שקיבלתם
              <br />
              כבר לא בתוקף
            </h3>
            <h3 className='secondaryHeading'>
              כדי לשמור על הפרטים שלכם,
              <br />
              נתחיל את התהליך מחדש
            </h3>
            <BtnSubmit
              type='button'
              text={'אוקיי'}
              className='continueButton w-m-196'
              onclick={() => {
                setShowExpiryPopup(false);
                props.resetProcess();
              }}
            />
          </>
        </Popup>
        <Popup
          showPopUp={showMaxPopup}
          onClose={async () => {
            setShowMaxPopup(false);
            props.resetProcess();
          }}>
          <>
            <ArrowSignErrorIcon noTop={true} />
            <h3 className='heading withSecondary'>לקחתם את זה לקצה!</h3>
            <h3 className='secondaryHeading'>
              הגעתם למקסימום הנסיונות להזין את הקוד
              <br />
              שקיבלתם. כדי לשמור על הפרטים שלכם,
              <br />
              נתחיל את התהליך מחדש
            </h3>
            <BtnSubmit
              type='button'
              text={'אוקיי'}
              className='continueButton'
              onclick={() => {
                setShowMaxPopup(false);
                props.resetProcess();
              }}
            />
          </>
        </Popup>
      </form>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    authentication: state.authentication,
    loginStage: state.authentication.loginStep,
  };
};

const mapDispatchToProps = {
  setOtpError,
  setRestrictedCodeError,
};

export default connect(mapStateToProps, mapDispatchToProps)(OTPInsert);
